import React from 'react';

import { useTranslation } from 'react-i18next';

import { Box, Divider, Typography } from '@mui/material';

import MobileQuatationItem from './QuatationItem';

import type { QuotationProductItem } from 'models/quotations/Quotations';

interface MobileQuatationListProps {
    items: QuotationProductItem[];
    handleChange: (props: any) => void;
    handleEvent: (props: any) => void;
}

const MobileQuatationList: React.FC<MobileQuatationListProps> = ({
    items,
    handleChange,
    handleEvent,
}) => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.FIELDS.QUOTATION_PRODUCTS',
    });

    return (
        <Box>
            <Typography color="gray">{t('TITLE')}</Typography>
            {items.map((item, key) => (
                <Box key={key}>
                    <MobileQuatationItem
                        row={item}
                        handleChange={handleChange}
                        handleEvent={handleEvent}
                        index={key}
                    />
                    {key !== items.length - 1 && <Divider />}
                </Box>
            ))}
        </Box>
    );
};

export default MobileQuatationList;
